import React, { Component } from "react";
import PropTypes from "prop-types";
import { CardTitle, FontIcon, Avatar } from "react-md";
import { getMembershipSuffix } from "../../../utils";

class RegistrationCardTitle extends Component {
  constructor(props) {
    super(props);
    this.handleIconClick = this.handleIconClick.bind(this);
  }

  handleIconClick(event) {
    event.stopPropagation();
    this.props.onIconClick();
  }

  render() {
    const {
      isMember,
      membershipTier,
      membershipType,
      isInactive,
      flagged,
      mainUser,
      requirements,
      registrationDuration,
      onTitleClick,
    } = this.props;
    return (
      <CardTitle
        onClick={onTitleClick}
        title={mainUser}
        subtitle={requirements}
        avatar={
          flagged ? (
            <Avatar
              role="presentation"
              suffix="red"
              icon={
                <FontIcon className="queue-item--warning">warning</FontIcon>
              }
              onClick={this.handleIconClick}
            />
          ) : isMember && !isInactive ? (
            <Avatar
              title={`Active ${membershipTier} membership ${membershipType}`}
              role="presentation"
              suffix="green"
              onClick={this.handleIconClick}
            >
              M{getMembershipSuffix(membershipTier)}
            </Avatar>
          ) : (
            <Avatar
              title="NON MEMBER"
              role="presentation"
              suffix="grey"
              onClick={this.handleIconClick}
            >
              NM
            </Avatar>
          )
        }
      >
        <div className="registration-duration">{registrationDuration}</div>
      </CardTitle>
    );
  }
}

RegistrationCardTitle.propTypes = {
  onIconClick: PropTypes.func,
  onTitleClick: PropTypes.func,
  isMember: PropTypes.bool,
  membershipTier: PropTypes.string,
  membershipType: PropTypes.string,
  isInactive: PropTypes.bool,
  flagged: PropTypes.bool,
  mainUser: PropTypes.string,
  requirements: PropTypes.string,
  registrationDuration: PropTypes.string,
};

export default RegistrationCardTitle;



// WEBPACK FOOTER //
// ./src/staff/components/Queue/Registration/RegistrationCardTitle.jsx